import { defineStore } from 'pinia'
import useRestaurantStore from '~/store/restaurant'
import { STORE_ID } from '~/constants/store'
import type { UiState as State } from '~/types/ui'
import { OnlineOrderType } from '~/types/restaurant'

const initialState = (): State => ({
  orderSuccessModal: undefined,
  hasRestaurantClosedToastDismissed: false,
  hasViewedCheckout: false,
  hasRelishPromptFired: false,
  hasNavigatedBackToHomeAfterCheckout: false,
  showAllergenModal: false,
  hideProfileCompletion: false,
  hasRecommendationMenuModalFired: false
})

/**
 * @name useUiStore
 * @description Store for user interface state across the app
 *
 */
const useUiStore = defineStore(STORE_ID.UI, {
  state: initialState,

  getters: {
    isOrderSuccessModalOpen(): boolean {
      return !!this.orderSuccessModal
    },
    /**
     * @description Shows the ordering notice if the restaurant is closed or unavailable.
     * Presented on GPageFooterOverlay and ViewProductItem
     * - Non-demo restaurant selected
     * - Restaurant is closed or unavailable
     * - Order type is not catering
     * - Toast has not been dismissed
     */
    showRestaurantClosedToast(): boolean {
      const restaurantStore = useRestaurantStore()
      return (
        restaurantStore.isNonDemoRestaurantSelected &&
        !restaurantStore.isOpen &&
        restaurantStore.orderConfig?.orderType !== OnlineOrderType.Catering &&
        !this.hasRestaurantClosedToastDismissed
      )
    }
  },
  persist: {
    pick: ['hasRelishPromptFired', 'hideProfileCompletion', 'hasRecommendationMenuModalFired']
  }
})

export default useUiStore
export { initialState }
